export default __webpack_public_path__ + "img/halfdan b.ae6f82ac.jpg";